var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2375 7.81667C16.4375 7.81667 16.6375 7.86667 16.8208 7.96667L22.9042 11.4833C23.2542 11.6833 23.4875 12.0667 23.4875 12.4833V19.5167C23.4875 19.9333 23.2708 20.3167 22.9042 20.5167L16.8042 24.0333C16.6375 24.1333 16.4375 24.1833 16.2208 24.1833C16.0208 24.1833 15.8208 24.1333 15.6375 24.0333L9.57083 20.5167C9.22083 20.3167 8.9875 19.9333 8.9875 19.5167V12.4833C8.9875 12.0667 9.20417 11.6833 9.57083 11.4833L15.6708 7.96667C15.8375 7.86667 16.0375 7.81667 16.2375 7.81667ZM16.2375 6C15.7208 6 15.2208 6.13333 14.7542 6.4L8.67083 9.91667C7.75417 10.45 7.1875 11.4167 7.1875 12.4833V19.5167C7.1875 20.5833 7.75417 21.55 8.67083 22.0833L14.7708 25.6C15.2375 25.8667 15.7375 26 16.2542 26C16.7708 26 17.2708 25.8667 17.7375 25.6L23.8375 22.0833C24.7542 21.55 25.3208 20.5833 25.3208 19.5167V12.4833C25.3208 11.4167 24.7542 10.45 23.8375 9.91667L17.7208 6.4C17.2708 6.13333 16.7542 6 16.2375 6Z",
    fill: "#FB8206"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.d75e0749ad226643093cd2b05a4df2bd.svg";
export { ForwardRef as ReactComponent };